//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {loadAppForm, checkIsFormWxapp} from '../../utils/wxapp-check'

    export default {
        data() {
            return {
                title: '明源云',
                tel: '电话咨询',
                experience: '专家预约',
                phone: 'tel:400-6027-009',
                isFromWxapp: loadAppForm() && checkIsFormWxapp()
            }
        }
    }



// WEBPACK FOOTER //
// ./src/vue-components/header/header.vue